import React, { useState } from 'react';
import { useAdminStats } from '../../hooks/useAdminStats';
import StatsCards from './StatsCards';
import UserStatsChart from './UserStatsChart';
import ContentStatsChart from './ContentStatsChart';
import ActivityStatsChart from './ActivityStatsChart';
import '../../admin-stats.css';

function StatsTab() {
  const [days, setDays] = useState(30);

  // Fetch stats for different endpoints
  const overviewStats = useAdminStats('/analytics/admin/overview', days);
  const userStats = useAdminStats('/analytics/admin/users', days);
  const contentStats = useAdminStats('/analytics/admin/content', days);
  const activityStats = useAdminStats('/analytics/admin/activity', days);

  const isLoading = overviewStats.loading || userStats.loading || contentStats.loading || activityStats.loading;

  const handleDateRangeChange = (newDays) => {
    setDays(newDays);
  };

  const handleRefresh = () => {
    overviewStats.refetch();
    userStats.refetch();
    contentStats.refetch();
    activityStats.refetch();
  };

  return (
    <div className="stats-tab">
      <div className="stats-header">
        <h1>Platform Statistics</h1>
        
        <div className="stats-controls">
          <div className="date-range-picker">
            <label>Time Period:</label>
            <select 
              value={days} 
              onChange={(e) => handleDateRangeChange(Number(e.target.value))}
              disabled={isLoading}
            >
              <option value={7}>Last 7 Days</option>
              <option value={30}>Last 30 Days</option>
              <option value={90}>Last 90 Days</option>
            </select>
          </div>

          <button 
            className="btn btn-secondary"
            onClick={handleRefresh}
            disabled={isLoading}
          >
            {isLoading ? 'Loading...' : '↻ Refresh'}
          </button>
        </div>
      </div>

      {overviewStats.error && (
        <div className="error-message" role="alert">
          <strong>Error:</strong> {overviewStats.error}
        </div>
      )}

      {isLoading ? (
        <div className="loading-container">
          <div className="loading-spinner">
            <div className="spinner"></div>
            <p>Loading statistics...</p>
          </div>
        </div>
      ) : (
        <div className="stats-content">
          {/* Overview Cards */}
          <StatsCards 
            overviewData={overviewStats.data} 
            loading={overviewStats.loading}
          />

          {/* User Statistics */}
          <UserStatsChart 
            userData={userStats.data}
            loading={userStats.loading}
          />

          {/* Content Statistics */}
          <ContentStatsChart 
            contentData={contentStats.data}
            loading={contentStats.loading}
          />

          {/* Activity Statistics */}
          <ActivityStatsChart 
            activityData={activityStats.data}
            loading={activityStats.loading}
          />
        </div>
      )}
    </div>
  );
}

export default StatsTab;
